import { useSearchQuery } from '@xti-external/frontend-kit-components'

export const useLoginNotAuthorizedSearchQueries = () => {
  const searchQuery = useSearchQuery()

  return {
    content: searchQuery?.content || '',
  }
}

const useCustom = () => {
  const search = useLoginNotAuthorizedSearchQueries()

  return {
    content: search.content,
  }
}

export default useCustom
